/**
 * The collection of i18n strings.
 *
 * @since 0.1.0
 */
export const I18N = {
  resizeBar: 'Drag to Resize/Double Click to Reset',
};
